import type { JSX } from 'react';

import { Dialog } from '../../components';
import ErrorBoundary from '../../shared/ErrorBoundary';
import Dashboard from '../Dashboard';
import Template from '../Template';
import { PAGE_NAME } from './constant';

function ProtectedRoute(): JSX.Element {
  return (
    <Template>
      <ErrorBoundary componentTitle={PAGE_NAME}>
        <Dashboard />
        <Dialog />
      </ErrorBoundary>
    </Template>
  );
}

export default ProtectedRoute;